import React from 'react';
import { Link } from 'react-router-dom';

/** Grid of internal links to related pages, used at the end of service pages. */
export function RelatedLinks({
  links
}: {
  links: [string, string][];
}) {
  return <div className="not-prose grid grid-cols-1 sm:grid-cols-2 gap-3 my-6" data-id="element-313" data-mp="84ugemcahbm4">
      {links.map(([to, label]) => <Link key={to} to={to} className="block px-4 py-3 bg-zinc-900/60 border border-zinc-800 rounded-lg text-white font-bold hover:border-red-900/60 hover:bg-zinc-800/60 transition-colors duration-150" data-id="element-314" data-mp="35j0ffjqya5l">
          {label} &rarr;
        </Link>)}
    </div>;
}